import React from 'react';

export const Social = () => {
  return (
    <div className="home__social">
     
      <a
        href="https://github.com/Maneshnarayanan"
        className="home__social-icon"
        target="_blank"
        rel="noreferrer"
      >
        <i class="uil uil-github-alt"></i>
      </a>
      <a
        href="https://www.linkedin.com/in/manesh-narayanan/"
        className="home__social-icon"
        target="_blank"
        rel="noreferrer"
      >
        <i class="uil uil-linkedin-alt"></i>
      </a>
    </div>
  );
}
